// extracted by mini-css-extract-plugin
export var Container = "default-module--Container--1QhVU";
export var Header = "default-module--Header--L9eZq";
export var Body = "default-module--Body--lu1zo";
export var Footer = "default-module--Footer--1Pn64";